const { makeStyles } = require("@material-ui/core");

const RAIL_WIDTH = 115;
const PANEL_WIDTH = 250;

export const sideNavStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },

    // -----------------------
    // LEFT RAIL
    // -----------------------
    railDrawer: {
        flexShrink: 0,
        width: RAIL_WIDTH,
    },

    railPaper: {
        width: RAIL_WIDTH,
        border: "none",
        backgroundColor: theme.palette.common.white,
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.15)",
        overflow: "hidden",
        zIndex: 1201,
    },

    railToolbar: {
        minHeight: 72,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    railLogo: {
        width: 56,
        height: "auto",
    },

    railScroll: {
        flex: 1,
        overflowY: "auto",
        paddingTop: 8,
    },

    railList: {
        width: "100%",
    },

    railItem: {
        position: "relative",
        cursor: "pointer",
        margin: "6px 3px",
        borderRadius: 12,
        padding: "10px 6px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        userSelect: "none",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "none",
            backgroundColor: "#f7f7f7",
        },
    },

    railArrow: {
        position: "absolute",
        top: 9,
        right: 6,
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 8,
        color: "#9ca3af",
        cursor: "pointer",
        transition: "transform 160ms ease, background-color 160ms ease",
    },
    railArrowOpen: {
        transform: "rotate(90deg)",
    },

    railItemActive: {
        backgroundColor: "#e8eefcff",
    },

    railIcon: {
        width: 37,
        height: 37,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    railText: {
        fontSize: 12,
        lineHeight: "12px",
        textAlign: "center",
        color: "#616161",
        maxWidth: 83,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    railBottom: {
        padding: "8px 0 10px",
    },

    railLogout: {
        display: "flex",
        justifyContent: "center",
        fontSize: 12,
    },

    railLogoutBtn: {
        minWidth: 0,
        padding: "8px 10px",
        "& .MuiButton-label": {
            flexDirection: "column",
            gap: 6,
            fontSize: 12,
            textTransform: "none",
            color: "#616161",
        },
        "& .MuiButton-startIcon": {
            margin: 0,
        },
    },

    // -----------------------
    // RIGHT PANEL
    // -----------------------
    panelDrawer: {
        flexShrink: 0,
        width: PANEL_WIDTH,
    },

    panelPaper: {
        width: PANEL_WIDTH,
        border: "none",
        left: RAIL_WIDTH,

        background: `
        linear-gradient(
        to bottom,
        rgba(255,255,255,0.95) 0%,
        rgba(255,255,255,0.50) 45%,
        rgba(255,255,255,0.25) 80%,
        rgba(255,255,255,0.5) 100%
        )
    `,

        backdropFilter: "blur(20px) saturate(140%)",
        WebkitBackdropFilter: "blur(20px) saturate(140%)",

        borderLeft: "1px solid rgba(255,255,255,0.6)",
        boxShadow: "0 25px 70px rgba(0,0,0,0.10)",
    },

    panelToolbar: {
        minHeight: 64,
        backgroundColor: "#f7f7f7",
        padding: "0 10px",
    },

    panelHeader: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
    },

    panelTitle: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
    },

    panelTitleIcon: {
        width: 28,
        height: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    panelTitleText: {
        fontWeight: 700,
        fontSize: 14,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    panelCloseBtn: {
        textTransform: "none",
        minWidth: 0,
    },

    panelScroll: {
        overflowY: "auto",
        padding: "8px 0",
    },

    panelList: {
        width: "100%",
    },

    panelNodeWrap: {
        width: "100%",
    },

    panelRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 42,
        paddingRight: 10,
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            textDecoration: "none",
            backgroundColor: "#EEF2F7",
        },
    },

    panelRowActive: {
        backgroundColor: "#e8eefcff",
        textDecoration: "none",

    },

    panelRowL2: {
        paddingLeft: 12,
    },

    panelRowL3: {
        paddingLeft: 24,
    },

    panelLeft: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
    },

    panelItemIcon: {
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },

    panelItemText: {
        fontSize: 13,
        color: "#4e4e4e",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    panelToggle: {
        cursor: "pointer",
        borderRadius: 10,
        padding: 6,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "#eeeeee",
        },
    },

    panelToggleSpacer: {
        width: 36,
        height: 36,
    },

    panelChildren: {
        paddingLeft: "21px",
        paddingBottom: 6,
    },

}));